import React from 'react';
import { Helmet } from 'react-helmet';

export default function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - EduConnect</title>
        <meta name="description" content="Privacy Policy for EduConnect platform" />
      </Helmet>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        
        <div className="prose prose-indigo max-w-none">
          <h2>1. Information We Collect</h2>
          <p>
            We collect information you provide directly to us, including:
          </p>
          <ul>
            <li>Name and contact information</li>
            <li>Profile information (subjects, languages, bio)</li>
            <li>Payment information</li>
            <li>Communications with other users</li>
            <li>Usage data and analytics</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>
            We use the collected information to:
          </p>
          <ul>
            <li>Provide and improve our services</li>
            <li>Process payments and bookings</li>
            <li>Communicate with you</li>
            <li>Ensure platform safety and security</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2>3. Information Sharing</h2>
          <p>
            We share information with:
          </p>
          <ul>
            <li>Other users (as necessary for the service)</li>
            <li>Service providers and partners</li>
            <li>Legal authorities when required</li>
          </ul>

          <h2>4. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information.
            However, no method of transmission over the Internet is 100% secure.
          </p>

          <h2>5. Your Rights</h2>
          <p>
            You have the right to:
          </p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Object to data processing</li>
            <li>Data portability</li>
          </ul>

          <h2>6. Cookies and Tracking</h2>
          <p>
            We use cookies and similar technologies to improve user experience and analyze
            platform usage. You can control cookie settings in your browser.
          </p>

          <h2>7. Children's Privacy</h2>
          <p>
            For users under 18, we require guardian consent and collect only necessary
            information in compliance with applicable laws.
          </p>

          <h2>8. International Data Transfers</h2>
          <p>
            Your information may be transferred to and processed in countries other than
            your own. We ensure appropriate safeguards are in place.
          </p>

          <h2>9. Changes to Privacy Policy</h2>
          <p>
            We may update this policy periodically. We will notify you of significant
            changes via email or platform notification.
          </p>

          <h2>10. Contact Us</h2>
          <p>
            For privacy-related questions, please contact our Data Protection Officer at{' '}
            <a href="mailto:privacy@educonnect.com" className="text-indigo-600 hover:text-indigo-500">
              privacy@educonnect.com
            </a>
          </p>
        </div>

        <div className="mt-8 text-sm text-gray-500">
          Last updated: March 19, 2025
        </div>
      </div>
    </>
  );
}